import { Link } from 'react-router-dom';
import { VESTA_CONTACT_EMAIL } from '@/brand/vesta-cfo-brand';
import { RdReveal } from './RedesignMotion';

export function RedesignFooter() {
  const year = new Date().getFullYear();

  return (
    <RdReveal variant="fadeIn" duration={0.6}>
      <footer className="site-foot">
        <div className="rd-container">
          <div className="foot-grid">
            <div>
              <Link className="site-brand" to="/" style={{ fontSize: 17 }}>
                <img src="/marketing/vesta-icon.svg" width={22} height={22} alt="" />
                Vesta CFO
              </Link>
              <p
                style={{
                  marginTop: 12,
                  fontSize: 13,
                  color: 'var(--rd-text-2)',
                  lineHeight: 1.6,
                  maxWidth: 240,
                }}
              >
                AI-assisted hotel KPI dashboard for independent and mid-size hotels.
              </p>
            </div>
            <div>
              <h4>Product</h4>
              <Link to="/features">Features</Link>
              <Link to="/pricing">Pricing</Link>
              <Link to="/product/integrations">Integrations</Link>
              <Link to="/inside">Inside Vesta</Link>
              <Link to="/security">Security</Link>
            </div>
            <div>
              <h4>Resources</h4>
              <Link to="/blog">Blog</Link>
              <Link to="/support">Support</Link>
              <Link to="/features">Features</Link>
              <Link to="/status">Status</Link>
            </div>
            <div>
              <h4>Company</h4>
              <Link to="/about">About</Link>
              <Link to="/careers">Careers</Link>
              <Link to="/press">Press</Link>
              <Link to="/contact">Contact</Link>
            </div>
            <div>
              <h4>Legal</h4>
              <Link to="/terms">Terms</Link>
              <Link to="/privacy">Privacy</Link>
              <Link to="/trust">DPA</Link>
              <Link to="/security">Security</Link>
            </div>
          </div>
        </div>
        <div className="foot-tag">
          <span>© {year} Vesta CFO · vestacfo.app</span>
          <span>{VESTA_CONTACT_EMAIL} · @vestacfo</span>
        </div>
      </footer>
    </RdReveal>
  );
}
